'use client';

import 'swiper/css';

import { ProductCard } from '@trwl/entities/product/card';
import { Container } from '@trwl/layout';
import { Path } from '@trwl/shared/lib/router';
import { setDuration, setShow } from '@trwl/store';
import { serializeFilterToQuery } from '@trwl/store/filter/serializer';
import { ReferralBlock } from '@trwl/views/main/components/ReferralBlock';
import { ReviewsBlock } from '@trwl/views/main/components/ReviewBlock';
import { reviews } from '@trwl/views/main/mainPage.constant';
import { MainPageProps } from '@trwl/views/main/mainPageProps';
import { ProductSliderBanner } from '@trwl/widgets/main/productSliderBanner';
import { TelegramReviewsBlock } from '@trwl/widgets/main/telegramReviewsBlock';
import { useUnit } from 'effector-react/compat';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect } from 'react';
import Marquee from 'react-fast-marquee';

import { ProductSlider } from '../../widgets/product/slider';
import { NewUserBonusesBlock } from './components/NewUserBonusesBlock';

export const MainPage = ({
  brands,
  trends,
  populars,
  sliders,
}: MainPageProps) => {
  const [changeShow, changeDuration] = useUnit([setShow, setDuration]);

  useEffect(() => {
    changeDuration(0);
    changeShow(false);
  }, [changeDuration, changeShow]);

  return (
    <Container>
      <h1 className="sr-only">Интернет-магазин кроссовок TRWL Store</h1>
      <div className="flex flex-col items-center w-full gap-20">
        <section aria-label="Баннеры и акции" className="w-full">
          <ProductSliderBanner sliders={sliders} />
        </section>
        <section aria-labelledby="user-bonuses" className="w-full">
          <NewUserBonusesBlock />
        </section>
        <section aria-labelledby="popular-products" className="w-full">
          <h2 id="popular-products" className="sr-only">
            Популярные товары
          </h2>
          <ProductSlider
            title={'Популярные'}
            products={populars.map((item, index) => (
              <ProductCard
                key={item.id}
                product={item}
                priority={index < 10}
                target={'_blank'}
              />
            ))}
          />
        </section>
        <section aria-label="Реферальная программа" className="w-full">
          <ReferralBlock />
        </section>
        <section aria-label="Бренды" className="w-full">
          <h2 className="sr-only">Популярные бренды</h2>
          <Marquee autoFill pauseOnHover speed={25}>
            {brands.map(
              (brand, key) =>
                brand.logoUrl && (
                  <div key={key} className="px-4 md:px-8">
                    <Link
                      href={`${Path.CATALOG}?filter=${serializeFilterToQuery({
                        brandIds: [brand.id],
                      })}`}
                    >
                      <Image
                        height={120}
                        width={120}
                        className="select-none w-[80px] md:w-[120px]"
                        src={brand.logoUrl}
                        alt={`Купить кроссовки ${brand.name} — брендовый магазин TRWL`}
                        priority={key < 10}
                      />
                    </Link>
                  </div>
                ),
            )}
          </Marquee>
        </section>
        <section aria-labelledby="reviews" className="w-full">
          <h2 id="reviews" className="sr-only">
            Отзывы покупателей
          </h2>
          <ReviewsBlock reviews={reviews} />
        </section>
        <section aria-labelledby="trendy-products" className="w-full">
          <h2 id="trendy-products" className="sr-only">
            Трендовые товары
          </h2>
          <ProductSlider
            title={'Трендовые'}
            products={trends.map((item) => (
              <ProductCard product={item} key={item.id} target={'_blank'} />
            ))}
          />
        </section>
        <section aria-label="Отзывы из Telegram" className="w-full">
          <TelegramReviewsBlock />
        </section>
      </div>
    </Container>
  );
};
